// Libraries
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './overlay.scss';

const Overlay = ({ closeFilter, isTransparent }) => (
    <div
        className={`overlay ${isTransparent ? 'transParent' : ''}`}
        onClick={closeFilter}
    />
);

Overlay.propTypes = {
    closeFilter: PropTypes.func,
    isTransparent: PropTypes.bool,
};

export default Overlay;
